<div
  (click)="selectItem()"
  class="tw-cursor-pointer tw-group tw-flex tw-bg-gray-100 dark:tw-bg-gray-800 tw-bg-opacity-30 dark:tw-bg-opacity-30 tw-border tw-border-solid tw-border-gray-300 dark:tw-border-gray-700 tw-border-opacity-50 tw-rounded-xl tw-transition-colors tw-duration-200 hover:tw-bg-gray-200 dark:hover:tw-bg-gray-800 hover:tw-bg-opacity-50 dark:hover:tw-bg-opacity-50 hover:tw-border-teal-600 hover:tw-border-opacity-60">
  <!-- Left Column - Main Content -->
  <button
    class="tw-flex-1 tw-h-full focus:tw-outline-none focus:tw-rounded-l-xl tw-py-3 tw-pl-3 tw-text-left"
    aria-label="Select this QuickBuild">
    <div class="tw-flex tw-items-start tw-gap-3 tw-mb-1">
      <div
        class="tw-text-gray-900 dark:tw-text-white tw-font-medium tw-flex tw-items-center tw-gap-1"
        [matTooltip]="currentItem?.description || ''"
        [matTooltipDisabled]="!currentItem?.description"
        matTooltipPosition="above">
        {{ currentItem?.name || 'Unnamed QuickBuild' }}
      </div>
      <div class="tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200">
        <span
          class="tw-bg-teal-600 tw-text-white tw-text-xs tw-font-medium tw-px-2 tw-py-1 tw-rounded-md">
          Select
        </span>
      </div>
    </div>
    <div
      *ngIf="currentItem?.description"
      class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-600 dark:tw-text-gray-400">
      <span
        class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-400"
        >{{ currentItem.description }}</span
      >
    </div>

    <div
      *ngIf="shouldShowCreator && currentItem?.createdBy && currentItem?.scope !== 'public'"
      class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-600 dark:tw-text-gray-400">
      <mat-icon class="tw-text-gray-600 dark:tw-text-gray-400 tw-h-5 tw-w-5 tw-text-[18px]"
        >person_outline</mat-icon
      >
      <span
        class="tw-text-sm tw-text-gray-600 dark:tw-text-gray-400"
        >{{ currentItem.createdBy }}</span
      >
    </div>
  </button>

  <!-- Right Column - Action Buttons -->
  <div
    class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-1 tw-px-3 tw-py-3 tw-min-h-full">
    <button
      type="button"
      class="tw-rounded-md tw-text-sm tw-text-gray-700 dark:tw-text-gray-300 tw-border tw-border-solid tw-border-gray-400 dark:tw-border-gray-500 tw-h-7"
      matTooltip="Edit QuickBuild"
      matTooltipPosition="above"
      (click)="editItem($event)">
      <mat-icon class="tw-text-[20px] tw-leading-[24px]">edit</mat-icon>
    </button>

    <!-- Admin Menu -->
    <app-admin-menu
      [scopeToggleText]="getScopeToggleText()"
      [scopeToggleIcon]="getScopeToggleIcon()"
      (copyToOrg)="onCopyToOrg($event)"
      (toggleScope)="onToggleScope($event)">
    </app-admin-menu>

    <div *ngIf="canDelete">
      <button
        (click)="deleteItem($event)"
        class="tw-rounded-md tw-text-sm tw-text-red-600 dark:tw-text-red-400 hover:tw-text-red-500 dark:hover:tw-text-red-300 tw-border tw-border-solid tw-border-red-400 dark:tw-border-red-500 tw-h-7"
        aria-label="Delete this QuickBuild">
        <mat-icon class="tw-text-[20px] tw-leading-[24px]">delete_outline</mat-icon>
      </button>
    </div>
  </div>
</div>
